module.exports = "//cdn.mxpnl.com/static/asset-cache/b31ec251a01d9c096c19d388f7008864/iron/common/assets/images/charts/retention-table.svg";